import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class HosesDepartmentService extends SingleDepartmentService {
  readonly DEPARTMENT_ID: number = 10;

  readonly NAME = 'Hoses';

  private _departmentId: number;

  set departmentId(value: number) {
    this._departmentId = value;
  }

  get departmentId(): number {
    return this._departmentId;
  }

  defaultRoutes(roles: string[]): boolean {
    if (roles.includes('HosesTrimming')) {
      this.router.navigate(['sb/hoses/only-trimming']);
      return true;
    } else if (roles.includes('HosesQC')) {
      this.router.navigate(['sb/hoses/quality-control']);
      return true;
    } else if (roles.includes('HosesOperator')) {
      this.router.navigate(['sb/hoses/scheduling/machines-operator']);
      return true;
    }
    if (
      roles.includes('HosesChief') ||
      roles.includes('HosesSupervisor') ||
      roles.includes('HosesLeader')
    ) {
      this.router.navigate(['sb/hoses/scheduling']);
      return true;
    }
    return false;
  }
}
